<template>
    <div class="modal fade" :id="modalId" tabindex="-1" :aria-labelledby="modalId+'Label'" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" :id="modalId+'Label'">{{ modalTitle }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    You selected: <strong>Hello</strong>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary">Add</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    modalId: String,
    modalTitle: String
})
</script>

<style scoped>
.modal-dialog {
    max-width: 700px;
}
.modal-backdrop {
    z-index: 3000 !important;
}

.modal {
    z-index: 3050 !important;
}
</style>
